import apiClient from 'api/apiClient';
import {
  UserBusinessResponse,
  BusinessSetupSessionResponse,
  BusinessObjectiveResponse,
} from '../Financial/types';

const BASE =
  (process.env.REACT_APP_USER_REST_API_BASE_URL ??
    'http://localhost:8080/api/v4/user') + '/business';

// ─── Business CRUD ────────────────────────────────────────────────────────────

export const listBusinesses = () =>
  apiClient.get<UserBusinessResponse[]>(BASE);

export const getBusiness = (id: number) =>
  apiClient.get<UserBusinessResponse>(`${BASE}/${id}`);

export const createBusiness = (payload: {
  businessName: string;
  templateType?: string;
  templateCode?: string;
  industry?: string;
  description?: string;
}) => apiClient.post<UserBusinessResponse>(BASE, payload);

export const updateBusiness = (
  id: number,
  payload: {
    businessName: string;
    templateType?: string;
    industry?: string;
    description?: string;
  },
) => apiClient.put<UserBusinessResponse>(`${BASE}/${id}`, payload);

export const archiveBusiness = (id: number) =>
  apiClient.delete(`${BASE}/${id}`);

// ─── Setup Session ────────────────────────────────────────────────────────────

export const getOrCreateSession = (id: number) =>
  apiClient.get<BusinessSetupSessionResponse>(`${BASE}/${id}/setup`);

export const saveStep = (
  id: number,
  payload: { sectionIndex: number; answer: string },
) =>
  apiClient.put<BusinessSetupSessionResponse>(
    `${BASE}/${id}/setup/step`,
    payload,
  );

export const completeSetup = (id: number) =>
  apiClient.post<UserBusinessResponse>(`${BASE}/${id}/setup/complete`);

// ─── Objectives ───────────────────────────────────────────────────────────────

export const listObjectives = (id: number) =>
  apiClient.get<BusinessObjectiveResponse[]>(`${BASE}/${id}/objectives`);

export const createObjective = (
  id: number,
  payload: {
    title: string;
    description?: string;
    targetDate?: string;
    ownerName?: string;
    progressNote?: string;
  },
) =>
  apiClient.post<BusinessObjectiveResponse>(
    `${BASE}/${id}/objectives`,
    payload,
  );

export const updateObjective = (
  id: number,
  objId: number,
  payload: {
    title: string;
    description?: string;
    targetDate?: string;
    ownerName?: string;
    progressNote?: string;
    status?: string;
  },
) =>
  apiClient.put<BusinessObjectiveResponse>(
    `${BASE}/${id}/objectives/${objId}`,
    payload,
  );

export const deleteObjective = (id: number, objId: number) =>
  apiClient.delete(`${BASE}/${id}/objectives/${objId}`);
